export interface ApplicantAppSettingsDTO {
    locale: string | undefined;
}

export const DefaultApplicantAppSettingsDTO: ApplicantAppSettingsDTO = {
    locale: undefined,
};
